// extracted by mini-css-extract-plugin
export var body = "Page-module--body--hPYHN";
export var inner = "Page-module--inner--3HKeR";
export var page = "Page-module--page--2Y5e7";
export var title = "Page-module--title--Z69a4";